export const isValidURL = (url: string) => {
  try {
    new URL(url)
  } catch (error) {
    console.error(error)

    return false
  }

  return true
}
